import React from 'react';
import { Link } from 'react-router-dom';

// BUILD TIMESTAMP: 2025-08-06-18-30-FORCE-REBUILD
const Landing: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900">PlatformRadar</h1>
            </div>
            <div className="flex space-x-4">
              <Link
                to="/login"
                className="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
            <span className="block">PlatformRadar</span>
            <span className="block text-blue-600">Revenue Intelligence</span>
          </h1>
          <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            Detect revenue opportunities across all platforms. Revenue intelligence for ambitious entrepreneurs.
          </p>
          <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
            <div className="rounded-md shadow">
              <Link
                to="/register"
                className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10"
              >
                Start Tracking Revenue
              </Link>
            </div>
            <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
              <Link
                to="/login"
                className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-gray-50 md:py-4 md:text-lg md:px-10"
              >
                Sign In
              </Link>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="mt-16">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="text-blue-600 text-2xl mb-4">📊</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Multi-Platform Analytics</h3>
              <p className="text-gray-600">
                Track revenue across Amazon, Etsy, Teachers Pay Teachers, and Printify in one dashboard.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="text-blue-600 text-2xl mb-4">🚀</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Revenue Intelligence</h3>
              <p className="text-gray-600">
                Get insights into your best-performing products and optimize for maximum profit.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="text-blue-600 text-2xl mb-4">⚡</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Real-Time Updates</h3>
              <p className="text-gray-600">
                See your revenue data update in real-time across all your platforms.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Landing; 